import { useSyncExternalStore } from "react";

// THE SITE MARK SWITCH (owner 2026-10-16: watermark everything we make; a
// paying customer may remove it). The server stamps the owner's badge on every
// studio's finished file unless the order says `watermark: false`
// (FaceShot-ChopShop-web/services/quicktools/watermark.js). One choice for the
// whole site, so every copy of a pay question (the corrido chat and its board)
// shows the same box; remembered in this browser, on by default.

const KEY = "fs_site_mark";
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return window.localStorage.getItem(KEY) !== "off";
  } catch {
    return true;
  }
}

let keep = typeof window === "undefined" ? true : read();

/** What the next order sends as `watermark`. */
export function keepSiteMark(): boolean {
  return keep;
}

export function setKeepSiteMark(v: boolean): void {
  keep = v;
  try {
    window.localStorage.setItem(KEY, v ? "on" : "off");
  } catch {
    /* a private window: this page still remembers it */
  }
  listeners.forEach((l) => l());
}

export function useKeepSiteMark(): [boolean, (v: boolean) => void] {
  const v = useSyncExternalStore(
    (l) => { listeners.add(l); return () => { listeners.delete(l); }; },
    () => keep,
    () => true,
  );
  return [v, setKeepSiteMark];
}
